import types from './types';
import {dispatch, getState} from '../../lib/store';
import API from '../../lib/api';
import {toast} from 'react-toastify';
import globalTypes from '../types';
import ModalsLib from '../../lib/modals';
import WS from '../../lib/websocket';
import {requestForToken} from '../../lib/firebase';

export const toggleActionModal = slug => {
    return {
        type: types.toggle,
        payload: slug
    }
}

export const openActionModal = slug => {
    return {
        type: types.open,
        payload: slug
    }
}

export const loadModals = () => async dispatch => {
    const {app} = getState();


}

export const AffiliateSignup = {
    selectGame: game => async dispatch => {
        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    game
                }
            }
        });
    },
    setStage: stage => async dispatch => {
        dispatch({
            type: types.stage.set,
            payload: {
                modal: 'affiliate_signup',
                stage
            }
        });
    },
    signUp: data => async dispatch => {
        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    button: true
                }
            }
        });

        const response = await API.call({
            path: '/affiliate/signup',
            body: data
        });

        dispatch({
            type: types.stage.toggleButton,
            payload: 'affiliate_signup'
        });

        if(response.success) {
            // Get user
            const userResponse = await API.call({
                path: '/auth/user/get'
            });

            if(!userResponse.success) {
                toast.error(userResponse.error);
                window.location.reload();
                return;
            }

            // Authorize WebSocket
            if(userResponse.user)
                WS.authorize(userResponse.user.userId, userResponse.user.userStringId);

            dispatch({
                type: globalTypes.user.loaded,
                payload: {
                    user: userResponse.user,
                    logins: userResponse.logins,
                    pending_voucher: userResponse.pending_voucher ? {
                        ...userResponse.pending_voucher,
                        expire_at: Date.now() + userResponse.pending_voucher.expire_at
                    } : userResponse.pending_voucher,
                    facebook: userResponse.facebook,
                    modals_list: userResponse.modals_list,
                    welcome_bonus: userResponse.welcome_bonus,
                    kyc_profile: userResponse.kyc_profile
                }
            });

            dispatch({
                type: types.stage.set,
                payload: {
                    modal: 'affiliate_signup',
                    stage: 'phone_confirmation'
                }
            });
        } else {
            dispatch({
                type: types.stage.update,
                payload: {
                    modal: 'affiliate_signup',
                    data: {
                        error: response.error
                    }
                }
            });
        }
    },
    changePhone: phone => async dispatch => {
        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    button: true
                }
            }
        });

        const response = await API.call({
            path: '/affiliate/signup/changePhone',
            body: {
                phone
            }
        });

        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    button: false
                }
            }
        });

        if(response.success) {
            // Update timestamp data
            dispatch({
                type: globalTypes.modals.phone_confirmation.update_user,
                payload: response.phone
            });

            dispatch({
                type: types.stage.set,
                payload: {
                    modal: 'affiliate_signup',
                    stage: 'phone_confirmation'
                }
            });
        } else {
            dispatch({
                type: types.stage.update,
                payload: {
                    modal: 'affiliate_signup',
                    data: {
                        error: response.error
                    }
                }
            });
        }
    },
    resend: () => async dispatch => {
        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    resend_button: true
                }
            }
        });

        const response = await API.call({
            path: '/affiliate/signup/resend',
        });

        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    resend_button: false
                }
            }
        });

        if(response.success) {
            // Update timestamp data
            dispatch({
                type: globalTypes.modals.phone_confirmation.update_user,
                payload: response.phone
            });

            toast.dismiss();
            toast.success(response.message);
        } else {
            dispatch({
                type: types.stage.update,
                payload: {
                    modal: 'affiliate_signup',
                    data: {
                        error: response.error
                    }
                }
            });
        }
    },
    verify: code => async dispatch => {
        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    button: true
                }
            }
        });

        const response = await API.call({
            path: '/affiliate/signup/verify',
            body: {
                code
            }
        });

        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    button: false
                }
            }
        });

        if(response.success) {
            toast.dismiss();
            toast.success(response.message);

            dispatch({
                type: globalTypes.modals.phone_confirmation.update_user,
                payload: response.phone
            });

            dispatch({
                type: types.stage.set,
                payload: {
                    modal: 'affiliate_signup',
                    stage: 'notifications'
                }
            });
        } else {
            dispatch({
                type: types.stage.update,
                payload: {
                    modal: 'affiliate_signup',
                    data: {
                        error: response.error
                    }
                }
            });
        }
    },
    getPushToken: () => async dispatch => {
        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    button: true
                }
            }
        });

        const token = await requestForToken(),
              {app} = getState();

        // if(token)
            // initForegroundMessaging();

        const response = await API.call({
            path: '/affiliate/signup/notifications',
            body: {
                token,
                is_mobile: app.isMobile
            }
        });

        dispatch({
            type: types.stage.update,
            payload: {
                modal: 'affiliate_signup',
                data: {
                    error: null,
                    button: false
                }
            }
        });

        if(response.success) {
            dispatch({
                type: globalTypes.user.welcome_bonus,
                payload: response.bonus
            });

            if(response.login)
                dispatch({
                    type: globalTypes.user.logins.create,
                    payload: response.login
                });

            if(response.pending_activations)
                dispatch({
                    type: globalTypes.user.pending_voucher,
                    payload: response.pending_activations
                });

            if(response.deposit_bonus_only)
                ModalsLib.open('wallet');
            else
                dispatch({
                    type: types.stage.set,
                    payload: {
                        modal: 'affiliate_signup',
                        stage: 'status'
                    }
                });
        } else {
            toast.dismiss();
            toast.error(response.error);
        }
    }
}

export const WelcomePackage = {
    toggleButton: state => dispatch => {
        dispatch({
            type: types.setData,
            payload: {
                modal: 'welcome_package',
                data: {
                    button: !state
                }
            }
        })
    },
    setGame: game => dispatch => {
        dispatch({
            type: types.setData,
            payload: {
                modal: 'welcome_package',
                data: {
                    game
                }
            }
        })
    },
    activateBonus: game => async dispatch => {
        dispatch({
            type: types.setData,
            payload: {
                modal: 'welcome_package',
                data: {
                    button: true
                }
            }
        });

        const response = await API.call({
            path: '/bonuses/welcome',
            body: {
                game
            }
        });

        if(!response.success) {
            toast.dismiss();
            toast.error(response.error);
        } else {
            dispatch({
                type: globalTypes.user.welcome_bonus,
                payload: response.bonus
            });

            if(response.login)
                dispatch({
                    type: globalTypes.user.logins.create,
                    payload: response.login
                });

            if(response.pending_activations)
                dispatch({
                    type: globalTypes.user.pending_voucher,
                    payload: response.pending_activations
                });

            if(response.deposit_bonus_only)
                ModalsLib.open('wallet');
        }

        dispatch({
            type: types.setData,
            payload: {
                modal: 'welcome_package',
                data: {
                    button: false
                }
            }
        });
    }
}